// Formato de display del panel de Orderflow Quantum (WP-OQ-panel-v2).
// Solo presentación: ningún valor de señal/nivel se calcula aquí (invariante
// permanente: el backend calcula, el frontend dibuja).

export const RESULT_LABEL = {
  tp1: 'TP1 ✓', tp2: 'TP2 ✓', tp3: 'TP3 ✓', sl: 'SL ✗',
  liquidation: 'Liquidación ✗', open: 'Abierta',
}

// Paleta de PRQ (QUANTUM_COLORS): 'Abierta' en neutro oscuro legible, no el
// gris #94a3b8 del I3 original (hallazgo de Marc, defecto 6).
export const RESULT_COLOR = {
  tp1: '#1B5E20', tp2: '#1B5E20', tp3: '#1B5E20',
  sl: '#B71C1C', liquidation: '#B71C1C', open: '#374151',
}

/**
 * Precio con la precisión REAL del símbolo -- `precision` viaja en el result
 * (detect() lo saca de computePriceFormat sobre las mismas velas que ve el
 * eje nativo, igual que rango_quantum). Sin precisión conocida: 2.
 */
export function formatPrice(v, precision) {
  if (v == null || !Number.isFinite(Number(v))) return '—'
  const p = Number.isInteger(precision) && precision >= 0 ? precision : 2
  return Number(v).toLocaleString('es-ES', { minimumFractionDigits: p, maximumFractionDigits: p })
}

/** Distancia % ya resuelta por el backend (`current_levels.pct`) -> '+0,4%'. */
export function formatPct(pct, { comma = true } = {}) {
  if (pct == null || !Number.isFinite(Number(pct))) return ''
  const n = Number(pct)
  const body = Math.abs(n).toFixed(1)
  return `${n >= 0 ? '+' : '−'}${comma ? body.replace('.', ',') : body}%`
}

export function formatTime(iso) {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
  } catch {
    return String(iso)
  }
}
